import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logos/Windows_logo_black.svg'
import _imports_1 from '@/assets/logos/Apple_logo_grey.svg'


const _withScopeId = n => (_pushScopeId("data-v-0d21baa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-unstyled" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "app-name" }
const _hoisted_5 = { class: "os-support" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "windows",
  title: "Windows support"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "mac",
  title: "MacOS support"
}
const _hoisted_8 = { class: "app-versions" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "planned-badge badge badge-xs" }, "Soon", -1))

import { computed } from 'vue'
import { OS, WorkspaceTypeInfo, currentOS, workspaceTypeInfos } from '@/rd/ResearchDataModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSupportGrid',
  props: {
    iconOnly: { type: Boolean },
    compact: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const appsRef = computed(() => {
  const os = currentOS
  if (props.compact && os) {
    return workspaceTypeInfos.filter(t => !t.hidden &&
      (t.supportedOn.includes(os) || t.plannedOn.includes(os)))
  }
  return workspaceTypeInfos.filter(t => !t.hidden && (t.supportedOn.length || t.plannedOn.length))
})

function isSupportedForView(t: WorkspaceTypeInfo) {
  const os = currentOS
  if (props.compact && os) {
    return t.supportedOn.includes(os)
  }
  return t.supportedOn.length > 0
}

function showOSIcon(t: WorkspaceTypeInfo, os: OS) {
  return t.supportedOn.includes(os) || (t.supportedOn.length == 0 && t.plannedOn.includes(os))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-support-grid", { compact: _ctx.compact }])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appsRef.value, (t) => {
        return (_openBlock(), _createElementBlock("li", {
          key: t.id,
          class: _normalizeClass({ 'icon-only': _ctx.iconOnly, 'supported': isSupportedForView(t) })
        }, [
          _createElementVNode("a", {
            href: t.infoUrl,
            target: "_blank",
            rel: "noopener"
          }, [
            _createElementVNode("img", {
              src: t.icon
            }, null, 8, _hoisted_3)
          ], 8, _hoisted_2),
          (!_ctx.iconOnly)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(t.product), 1),
                (!_ctx.compact)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_5, [
                        (showOSIcon(t, 'windows'))
                          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                          : _createCommentVNode("", true),
                        (showOSIcon(t, 'mac'))
                          ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_8, "v" + _toDisplayString(t.versions), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_9
        ], 2))
      }), 128))
    ])
  ], 2))
}
}

})